import productSplitService from './ProductSplitService';

export const storeSplitDataOnAdd = (customerId, productData) => {
  if (!customerId || !productData || !productData.id && !productData.product_id) {
    return;
  }

  const productId = productData.id || productData.product_id;
  
  productSplitService.storeSplitData(customerId, productId, productData);
};

export const handleTypeToggle = async (
  item, 
  newType, 
  customerId, 
  onRemove, 
  onAddToCart
) => {
  if (!customerId || !item.product_id) {
    return false;
  }

  const splitData = productSplitService.getSplitData(customerId, item.product_id);
  
  if (!splitData || splitData.split !== "2") {
    return false;
  }

  const newPrice = newType === "Box" 
    ? splitData.sales_box_price 
    : splitData.sales_piece_price;

  const productDataForReAdd = {
    product_id: item.product_id,
    product_code: item.code || item.product_code || splitData.product_code,
    product_name: item.name || item.product_name || splitData.product_name,
    code: item.code || item.product_code || splitData.product_code,
    name: item.name || item.product_name || splitData.product_name,
    price: newPrice,
    sales_box_price: splitData.sales_box_price,
    sales_piece_price: splitData.sales_piece_price,
    type: newType,
    order_type: newType,
    qty: item.qty,
    sub_total: (parseFloat(newPrice) * parseInt(item.qty)).toFixed(2),
    tax_rate: splitData.tax_rate,
    rate: splitData.tax_rate,
    split: splitData.split,
    noOfPieceInBox: splitData.noOfPieceInBox,
    isContractPriceApplied: item.isContractPriceApplied || "N",
    discount: item.discount || "0",
    is_promoted: item.is_promoted || "0",
    promo_id: item.promo_id || "",
    promo_type: item.promo_type || ""
  };

  try {
    await onRemove(item.id);
    
    await onAddToCart(productDataForReAdd);
    
    return true;
  } catch (error) {
    console.error('Error toggling type:', error);
    return false;
  }
};

export const clearSplitDataForCustomer = (customerId) => {
  if (customerId) {
    productSplitService.clearCustomerData(customerId);
  }
};

export const getSplitPrice = (customerId, productId, type) => {
  return productSplitService.getPrice(customerId, productId, type);
};

